<template>
  <g>
    <path
      d="M16.7046 3.39992C16.9755 2.97482 17.3696 2.87371 17.7019 3.16867L22.502 7.4355C22.9464 7.83056 23.127 8.79117 22.9051 9.58141C22.6829 10.3715 22.1425 10.6927 21.698 10.2981L17.5484 6.60838L13.203 16.2671C12.938 16.856 12.4774 17.0352 12.0979 16.6984L7.79471 12.8732L3.43996 18.6797C3.04243 19.2097 2.47849 19.0673 2.18017 18.3609C1.88203 17.6542 1.96215 16.6516 2.35947 16.1212L7.15955 9.721L7.26619 9.59808C7.52273 9.34723 7.83509 9.33222 8.10175 9.56891L12.2503 13.2566L16.5968 3.59993L16.7046 3.39992Z"
    />
  </g>
</template>
